import getLocale from "../locale"
export const handleLocaleChange = async (language, setAppState) => {
	// Valida setAppState
	if (!setAppState || typeof setAppState !== 'function') {
		console.error('handleLocaleChange: Invalid setAppState function', setAppState)
		return
	}
	
	try {
		if (!language) {
			const lang = localStorage.getItem("locale")
			const { locale } = await getLocale(lang)
			setAppState({ language, locale })
		} else {
			const { locale } = await getLocale(language)
			localStorage.setItem("locale", language)
			setAppState({ lang: language, language, locale })
		}
	} catch (error) {
		console.error('Error in handleLocaleChange:', error)
	}
}
